// extracted by mini-css-extract-plugin
module.exports = {"portraitContainer":"orientation-lock_portraitContainer__14Z-n","portraitMessage":"orientation-lock_portraitMessage__1abgx"};